exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .mat-radio-label-content {\n  padding-right: 20px !important; }\n\n.form-radio {\n  font-size: 14px; }\n\n::ng-deep .confirm-labtest-line-2 {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  line-height: 30px;\n  padding-left: 20px;\n  padding-top: 7px;\n  padding-bottom: 50px; }\n\n::ng-deep .confirm-labtest-line-1 {\n  padding-left: 5px; }\n\n::ng-deep .confirm-labtest-break {\n  padding-right: 10px;\n  padding-left: 10px; }\n\n.lab_test_title {\n  border: 2px solid black;\n  padding: 10px;\n  margin: 20px 0;\n  font-size: 1.1em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/lab-test/lab-test.componenet.scss
// module id = ../../../../../src/app/pages/consultation-history/lab-test/lab-test.componenet.scss
// module chunks = main